import { Box, Button, Grid } from '@mui/material';
import React, { useState } from 'react';
import { ReactHookForm } from '../../../../components/hook-form/react-hook-form.component';
import FormInputPassword from '../../../../components/hook-form/form-input-password.component';
import { useSaveData } from '../../../../hooks/useSaveData';
import { passwordApiKeyStore } from '../../../../api/password-api-key-store';
import { useReactHookForm } from '../../../../hooks/useReactHookForm';
import * as Yup from 'yup';
import { useAuthorize } from '../../../../hooks/use-authorize';
import { UserPermissionName } from '../../../../models/user-permission-name';

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .matches(/^(?=.*[A-Z])/, 'Password must contain at least one uppercase letter') // Enforces uppercase
    .matches(/^(?=.*[@$!%*?&])/, 'Password must contain at least one special character')
    .min(16, 'Password must be at least 16 characters long'),

  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Password and Confirm password must match'),
});

interface IEmployeePasswordReset {
  handleClose: () => void;
  userID: any;
}

const EmployeePasswordReset = ({ handleClose, userID }: IEmployeePasswordReset) => {
  const formValue = useReactHookForm({
    defaultValues: {},

    yupSchema: validationSchema,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { isLoading, mutateAsync } = useSaveData<any>(passwordApiKeyStore.resetPasswordAdmin());

  const handleSubmit = async (data: any) => {
    mutateAsync({
      data: {
        userID: !userID ? 0 : userID,
        newPassword: data?.password,
      },
    }).then((data) => {
      handleClose();
    });
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <div>
      {' '}
      <Box
        sx={{
          display: 'inline-block',
          borderRadius: '12px',
          backgroundColor: '#fff',
          padding: '60px',
          boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
        }}
      >
        <h2 style={{ marginBottom: 20, marginTop: -20 }}> Reset Password </h2>
        <ReactHookForm
          formName="RESET_PASSWORD_FORM"
          onSubmit={handleSubmit}
          formContextProps={formValue}
          isBusy={isLoading}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={6}>
              {/* <FormInput label="Current password" type="password" name="password" /> */}
              <FormInputPassword label="Password" name="password" type="password" />
            </Grid>

            <Grid item lg={12} sm={12} xl={12} xs={6}>
              {/* <FormInput label="Confirm password" type="password" name="confirmPassword" /> */}
              <FormInputPassword label="Confirm password" type="password" name="confirmPassword" />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                onClick={() => handleClose()}
                type="button"
                variant="outlined"
                fullWidth
                style={{ maxWidth: '100px' }}
              >
                CANCEL
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isLoading || isReadOnlyPermission}
                fullWidth
                style={{ maxWidth: '100px' }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </ReactHookForm>
      </Box>
    </div>
  );
};

export default EmployeePasswordReset;
